export default __webpack_public_path__ + "static/media/noodle.0ca46de3.svg";